// extracted by mini-css-extract-plugin
export default {"button":"LogoffButton_button__dZE3U"};